import { MemberInfo } from '../common/PSXHeader/ObapiDemo/memberProfile';

/**
 * Determines if a member is eligible for PCP designation suppression based on isPcpNotRequired flag
 */
export function isPcpSuppressionEligible(
  memberData: MemberInfo | null | undefined,
  enableNonGatedPcpSuppression: boolean
): boolean {
  if (!memberData || !enableNonGatedPcpSuppression) {
    return false;
  }

  return memberData.isPcpNotRequired === true;
}
